var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.378 8.406V23.16L1 21.833V10.014l2.378-1.608z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.476 10.014v2.448l12.937-7.483L16.175 4l-10.7 6.014z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.825 21.832v-2.447l10.35 5.734 2.028-1.26-6.434-4.056 2.167-1.329 6.434 3.847 2.029-1.26-6.225-3.845 2.238-1.19 5.664 3.358v-2.937L20.79 14.49l2.028-1.4 3.636 2.099v6.293l-10.49 6.573-10.139-6.224z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11.35 11.902 1.958 1.189 7.482-3.775 7.902 4.615.42 9.23L31 21.484v-11.47l-2.308-1.258v2.378L20.79 6.517l-9.44 5.385z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ASK.c669712533bfab43b578e6c93c7fb596.svg";
export { ForwardRef as ReactComponent };